import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    marginTop: 12,
  },
  reportTitle: {
    fontSize: 20,
    textAlign: "center",
    textTransform: "uppercase",
    backgroundColor: "#0B5F68",
    color: "white",
    fontFamily: "Times-Bold",
    width: "400px",
    marginLeft: "auto",
    marginRight: "auto",
    height: 40,
    paddingTop: 8,
  },
});

const YourCard = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>*** Your Id Card ***</Text>
  </View>
);

export default YourCard;
